const RELATIVE_STEPS = [
  { limit: 60, value: 1, unit: "second" },
  { limit: 3_600, value: 60, unit: "minute" },
  { limit: 86_400, value: 3_600, unit: "hour" },
  { limit: 604_800, value: 86_400, unit: "day" },
  { limit: 2_592_000, value: 604_800, unit: "week" },
  { limit: 31_536_000, value: 2_592_000, unit: "month" },
] as const;

const safeParseIso = (value: string) => {
  const parsed = Date.parse(value);
  return Number.isNaN(parsed) ? null : new Date(parsed);
};

export const formatRelativeTime = (
  dateISO: string,
  formatter: Intl.RelativeTimeFormat,
) => {
  const targetDate = safeParseIso(dateISO);
  if (!targetDate) {
    return formatter.format(0, "second");
  }

  const target = targetDate.getTime();
  const now = Date.now();
  const diffInSeconds = Math.round((target - now) / 1000);
  const absSeconds = Math.abs(diffInSeconds);

  for (const step of RELATIVE_STEPS) {
    if (absSeconds < step.limit) {
      return formatter.format(
        Math.round(diffInSeconds / step.value),
        step.unit,
      );
    }
  }

  return formatter.format(Math.round(diffInSeconds / 31_536_000), "year");
};
